import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/components/LanguageSelector.scss';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage, getCurrentLanguage, availableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  const currentLang = getCurrentLanguage();

  return (
    <Dropdown 
      show={isOpen} 
      onToggle={(isOpen) => setIsOpen(isOpen)}
      className="language-selector"
    >
      <Dropdown.Toggle 
        variant="link" 
        id="language-dropdown"
        className="language-toggle"
      >
        <span className="language-flag">{currentLang.flag}</span>
        <span className="language-name d-none d-md-inline">{currentLang.name}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="language-menu">
        {availableLanguages.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={currentLanguage === lang.code ? 'active' : ''}
          >
            <span className="language-flag">{lang.flag}</span>
            <span className="language-name">{lang.name}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector; 